import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "upload-wrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "font_family icon-CloudUpload1 icon-upload" }),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "ant-upload-hint" }, "Drag and drop to upload or"),
    /*#__PURE__*/_createElementVNode("a", { class: "m-l-10" }, "browse for files")
  ])
], -1)
const _hoisted_2 = { class: "draw-bm cursor-p" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Upload")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    title: _ctx.title,
    width: 500,
    visible: _ctx.visible,
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_upload_dragger, {
        "file-list": _ctx.fileList,
        "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileList) = $event)),
        name: "file",
        multiple: true,
        headers: _ctx.headers,
        "before-upload": _ctx.handleBeforeUpload,
        onChange: _ctx.handleUpload
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["file-list", "headers", "before-upload", "onChange"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_button, {
          type: "primary",
          class: "cursor-p",
          onClick: _ctx.handleClickUpload
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          type: "primary",
          class: "m-l-10 cursor-p",
          onClick: _ctx.handleClose
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["title", "visible", "onClose"]))
}